import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Profile from '../components/profile';
//import dataProfiles from "../db/profiles.json";
import dataCompanies from "../db/companies.json";
import SocialLinks from '../components/social_links';
import ContactUs from '../components/contact_us';
import { downloadVCard, convertImageToBase64 } from '../components/download_vcard';

const PROFILES_URL =
    "https://floricentrastorage.blob.core.windows.net/floricentra-assets/vcardwebsite/db/profiles.json";

function VCardPage() {
    const { code } = useParams();
    const [profiles, setProfiles] = useState([]);
    const [filteredProfile, setFilteredProfile] = useState();
    const [filteredCompany, setFilteredCompany] = useState();
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                setError("");
                const response = await fetch(PROFILES_URL, { cache: "no-store" });
                if (!response.ok) throw new Error("Error al cargar el archivo JSON");
                const data = await response.json();
                if (!cancelled) setProfiles(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error(err);
                if (!cancelled) setError("No se pudo cargar la lista de perfiles.");
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            if (!code || profiles.length === 0) {
                setFilteredProfile(null);
                setFilteredCompany(null);
                return;
            }

            // Búsqueda por coincidencia exacta (case-insensitive). Cambia a includes si lo necesitas parcial.
            const codeLc = String(code).toLowerCase();
            const prof = profiles.find(
                (p) => String(p.code).toLowerCase() === codeLc
            );

            if (!prof) {
                setFilteredProfile(null);
                setFilteredCompany(null);
                return;
            }

            // Buscar compañía asociada
            const company = dataCompanies.find(
                (c) => String(c.code) === String(prof.codeCompany)
            );

            // Convertir imagen a base64 si hay imageUrl
            let photo = null;
            try {
                if (prof.imageUrl) {
                    photo = await convertImageToBase64(prof.imageUrl);
                }
            } catch {
                // Si falla, seguimos sin foto
                photo = null;
            }

            if (!cancelled) {
                setFilteredCompany(company || null);
                setFilteredProfile({ ...prof, photo, company: company || null });
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [code, profiles]);

    return (
        <>
            <div className="qr_page_loader" style={{ display: "none" }}>
                <img className="loader_img" src={filteredCompany?.logo}></img>
            </div>
            <div className="qrc_page_wrapper thinScrollBar">
                <div className="pg_background"></div>
                <div className="qrc_page_inner">
                    {filteredProfile ? (<Profile data={filteredProfile}></Profile>) : ""}
                    {filteredProfile ? (<ContactUs data={filteredProfile} company={filteredCompany}></ContactUs>) : ""}
                    {filteredCompany ? (<SocialLinks data={filteredCompany}></SocialLinks>) : ""}
                </div>
                <div className="extra_button_wrapper">
                    {/* <div style={{ display: "flex" }}>
                        <button className="btn " id="btn_page_qr_code">
                            <i className="icon-qrcode"></i>
                        </button>
                        <button className="btn " id="btn_share_page">
                            <i className="icon-file_upload_1"></i>
                        </button>
                    </div> */}
                    <a rel="nofollow noopener noreferrer" href="#" className="qrc_addtocontact" onClick={(event) => { event.preventDefault(); downloadVCard(filteredProfile); }}>
                        <div className="qrc_addtocontact_text">Add to Contact</div>
                        <div className="qrc_addtocontact_circle">
                            <span className="icon-add_1"></span>
                        </div>
                    </a>
                </div>
            </div>
        </>
    );
}

export default VCardPage